import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { addPayType, updategetpayType, updatepayType } from "@/api/aymentsdk/aymentsdk";
export default {
  data: function data() {
    return {
      dialogFormVisible: false,
      searchData: {
        pay_name: "",
        pay_mark: "",
        icon: ""
      },
      fileList: [],
      rules: {
        pay_name: [{
          required: true,
          message: "类型标名",
          trigger: "blur"
        }],
        pay_mark: [{
          required: true,
          message: "类型标识",
          trigger: "blur"
        }],
        icon: [{
          required: true,
          message: "类型ICON",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(id) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$updategetpayTy, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

                if (!id) {
                  _context.next = 8;
                  break;
                }

                _context.next = 4;
                return updategetpayType({
                  id: id
                });

              case 4:
                _yield$updategetpayTy = _context.sent;
                data = _yield$updategetpayTy.data;
                _this.searchData = _objectSpread(_objectSpread({}, _this.searchData), data);
                _this.fileList = [{
                  url: data.icon
                }];

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.searchData.id = '';
      this.clearData();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var req = _this2.searchData.id ? updatepayType : addPayType;
          req(_this2.searchData).then(function (res) {
            if (res.status == 200) {
              Message.success('操作成功');

              _this2.$emit("refreshDataList");

              _this2.resetForm("ruleForm");
            }
          });
        }
      });
    },
    BgUrl: function BgUrl(e) {
      this.fileList = e;
      this.searchData.icon = e[0].url;
    },
    clearData: function clearData() {
      this.searchData = {
        id: this.searchData.id,
        pay_name: "",
        pay_mark: "",
        icon: ""
      };
      this.$refs.ruleForm.resetFields();
      this.fileList = [];
    }
  }
};